import React from 'react';
import { observer } from 'mobx-react-lite';
import { roundInfoStore } from '@pascal/pascal-core/shared/core/store';
import { useTranslation } from '@pascal/pascal-core';
import { gameStore } from '../../../store';
import { globalTranslationKeys } from '../../../enums';
import ImgBall from '../../../assets/images/img-ball.png';

export const CountDown = observer(() => {
  const t = useTranslation();
  const { PlaceYourBets } = globalTranslationKeys;
  const { time, oddData } = gameStore;
  const { duration } = roundInfoStore;

  return (
    <>
      {time && !oddData ? (
        <div className='timer-game-circular-wrapper'>
          <div className='timer-game-circle-inner'>
            <svg viewBox='1 1 100 100'>
              <path
                d='M 50,50 m 0,-47a 47,47 0 1 1 0,94a 47,47 0 1 1 0,-94'
                fillOpacity='0'
                fill='none'
                r='12'
                stroke='#CACACA'
                strokeLinecap='round'
                strokeWidth='4'
                style={{
                  animationDuration: `${duration}s`,
                  animationDelay: `${-(duration - gameStore.timerDuration)}s`,
                }}
              />
            </svg>
            <div className='t-circle-ball'>
              <div className='circular-ball-inner-content'>
                <p className='t-circle-ball-number'>{time}</p>
              </div>
              <div
                className='t-ball-r-holder'
                style={{
                  animationDuration: `${duration}s`,
                  animationDelay: `${-(duration - gameStore.timerDuration)}s`,
                }}
              >
                <div className='t-ball-r-inner'>
                  <img className='timer-rotate-img' src={ImgBall} alt='' />
                </div>
              </div>
            </div>
          </div>
          <p className='odd-timer-txt' title={t(PlaceYourBets)}>
            {t(PlaceYourBets)}
          </p>
        </div>
      ) : (
        <></>
      )}
    </>
  );
});
